function initSingleProduct() {

	let singleProductPage = document.querySelector('.single-product');
	if( singleProductPage ){

		let thumbnails = document.querySelector('.swiper-thumbnail');
		if( thumbnails ) {
			let thumbnailSwiper = new Swiper(".swiper-thumbnail", {
				spaceBetween: 10,
				slidesPerView: 4,
				freeMode: true
			});
			let mainSlider = new Swiper('.swiper', {
				thumbs: {
					swiper: thumbnailSwiper,
				}
			});
		}else{
			let mainSlider = new Swiper('.swiper', {
				thumbs: {
					swiper: thumbnailSwiper,
				}
			});
		}

	}

}
